module.exports = __webpack_public_path__ + "static/media/cat-logo.8fe55bbb.png";